module.exports = __webpack_public_path__ + "img/rku10-5.cc29016c.png";